import React from 'react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';

export const Login: React.FC = () => {
  const { keycloak } = useKeycloak();

  // Redirect if already authenticated
  if (keycloak?.authenticated) {
    window.location.href = '/map';
    return null;
  }

  const handleKeycloakLogin = () => {
    if (keycloak) {
      keycloak.login();
    } else {
      toast.error('Authentication service is not available');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="mx-auto h-16 w-16 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full flex items-center justify-center shadow-lg">
            <svg className="h-10 w-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Welcome to Finderz AI
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Your intelligent data center construction platform
          </p>
        </div>
        
        <div className="mt-8">
          <div className="bg-white rounded-lg shadow-xl p-8">
            <div className="space-y-6">
              <div className="text-center">
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  Secure Authentication
                </h3>
                <p className="text-sm text-gray-600">
                  Sign in with your organization account through our secure authentication service
                </p>
              </div>
              
              <button
                type="button"
                onClick={handleKeycloakLogin}
                className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-base font-medium rounded-lg text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 transform hover:scale-105 shadow-lg"
              >
                <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                  <svg className="h-5 w-5 text-blue-200 group-hover:text-blue-100" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                  </svg>
                </span>
                Continue with Keycloak
              </button>

              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-gray-200" />
                </div>
                <div className="relative flex justify-center text-xs">
                  <span className="px-2 bg-white text-gray-500">SECURE SSO</span>
                </div>
              </div>

              <div className="text-center space-y-2">
                <p className="text-xs text-gray-500">
                  By continuing, you agree to our
                </p>
                <div className="flex justify-center space-x-3">
                  <Link to="/terms" className="text-xs font-medium text-blue-600 hover:text-blue-500">
                    Terms of Service
                  </Link>
                  <span className="text-xs text-gray-400">•</span>
                  <Link to="/privacy" className="text-xs font-medium text-blue-600 hover:text-blue-500">
                    Privacy Policy
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6 text-center">
            <p className="text-sm text-gray-600">
              Need help? Contact{' '}
              <a href="mailto:help@finderz.ai" className="font-medium text-blue-600 hover:text-blue-500">
                help@finderz.ai
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}; 